import React from "react";
import { Shirt, Factory, Globe2, ArrowRight } from "lucide-react";
import { useEnquiry } from "./EnquiryProvider";

/**
 * Three doors into the site, one per question a buyer arrives with. Puts
 * Products / Capabilities / Markets one click from the top instead of a
 * scroll through everything.
 */
const PATHS = [
  {
    icon: Shirt,
    q: "What can you make for me?",
    a: "Knits, shirts, casuals, nightwear and kids wear — browse the lines by category.",
    href: "#collections",
    cta: "See products",
  },
  {
    icon: Factory,
    q: "Can you handle my volume?",
    a: "Capacity, machinery, seats per unit and certifications, laid out plainly.",
    href: "#capabilities",
    cta: "See capabilities",
  },
  {
    icon: Globe2,
    q: "Do you already ship to my market?",
    a: "Brands we supply in the UK, Turkey, the Gulf, Latin America, the US and South Africa.",
    href: "#clients",
    cta: "See markets",
  },
];

export default function PathFinder() {
  const enquiry = useEnquiry();
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="bg-white relative z-10">
      <div className="kse-container -mt-10 lg:-mt-14">
        <div className="grid md:grid-cols-3 gap-4 lg:gap-5">
          {PATHS.map(({ icon: Icon, q, a, href, cta }) => (
            <button
              key={href}
              type="button"
              onClick={() => go(href)}
              className="group text-left bg-white rounded-3xl border border-slate-100 shadow-[0_20px_50px_-24px_rgba(13,22,64,0.35)] p-6 lg:p-7 hover:-translate-y-1 hover:shadow-[0_28px_60px_-24px_rgba(13,22,64,0.45)] transition-all"
            >
              <div className="w-11 h-11 rounded-2xl bg-blue-50 text-[#2b3aa0] flex items-center justify-center mb-5">
                <Icon size={22} strokeWidth={1.8} />
              </div>
              <h3 className="text-lg font-extrabold text-[#0f1a3d] leading-snug">{q}</h3>
              <p className="text-slate-500 text-sm mt-2 leading-relaxed">{a}</p>
              <span className="inline-flex items-center gap-1.5 text-[#2b3aa0] font-semibold text-sm mt-5">
                {cta} <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
              </span>
            </button>
          ))}
        </div>
        <div className="mt-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4 rounded-3xl bg-slate-50 border border-slate-100 px-6 py-5">
          <p className="text-[#0f1a3d] font-semibold">
            Already know what you need? <span className="text-slate-500 font-normal">Three quick steps, quoted within a working day.</span>
          </p>
          <button onClick={() => enquiry?.openEnquiry()} className="kse-btn kse-btn--accent self-start sm:self-auto">
            Start a manufacturing enquiry <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
}
